module.exports = __webpack_public_path__ + "static/media/logo2.0c030197.png";